// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1xtrk","title":"Header_title__23snU","side":"Header_side__2gF3B"};